import { OpenapiSingleton } from "../OpenapiSingleton";
import { isApp } from "../utils";
import { loadScript } from "./utils/loadScript";
import appState from "src/model/state";

// docs de prerender : https://docs.prerender.io/docs/33-overview-of-prerender-crawlers

declare global {
  interface Window {
    OneTrust: {
      OnConsentChanged: (callback: () => void) => void;
      GetConsentStatus: () => boolean;
    };
    PRERENDER?: boolean;
  }
}


function isBot(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();

  const isPrerenderCrawler = userAgent.includes('prerender (+https://github.com/prerender/prerender)');
  
  const isHeadlessChrome = userAgent.includes('headlesschrome/');
  
  const isPrerenderMode = window.PRERENDER === true;
  
  const searchEngineBots = [
    'googlebot',           
    'bingbot',             
    'slurp',               
    'duckduckbot',         
    'baiduspider',         
    'yandexbot',           
    'sogou',               
    'exabot',              
    'facebot',             
    'ia_archiver',         
    'gptbot'               
  ];
  
  const isSearchEngineBot = searchEngineBots.some(bot => 
    userAgent.includes(bot)
  );
  
  const isHeadlessBrowser = navigator.webdriver === true;
  const isFromBot =  isPrerenderCrawler || isHeadlessChrome || isPrerenderMode || isSearchEngineBot || isHeadlessBrowser;
  
  return isFromBot;
}

function getCookiesConsent(data) {
  return data?.support?.cookies?.cookiesConsent?.oneTrust?.ids?.web;
}

export const oneTrustCookieScriptLoad = async (cookiesPopUpEnabledInApps:boolean) => {
  if (isBot()) {
    return;
  }

  const { market } = appState.get();

  const isAppEnvironment = isApp();

  if (!isAppEnvironment || (isAppEnvironment && cookiesPopUpEnabledInApps)) {
    try {
      const data = await OpenapiSingleton.CatalogApiInstance.oneTrustIdAndLoadScript(market?.marketId?.toString() ?? "");
      const cookiesConsentId = getCookiesConsent(data);
      
      if (cookiesConsentId) {
        const cookiesArgsForScript = {
          src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
          type: "text/javascript",
          onload: () => console.log("[OneTrust] Script loaded for real user"),
          id: cookiesConsentId,
          dataDocumentLanguage: true
        }
        loadScript(cookiesArgsForScript)
      } else {
        console.log("[OneTrust] Cookies Consent is not defined.");
      }
    } catch (error) {
      console.error("[OneTrust] Error loading cookie script:", error);
    }
  }
}

